import { render } from "./CheckoutView.vue?vue&type=template&id=6fad1fb2&scoped=true"
import script from "./CheckoutView.vue?vue&type=script&lang=js"
export * from "./CheckoutView.vue?vue&type=script&lang=js"

import "./CheckoutView.vue?vue&type=style&index=0&id=6fad1fb2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fad1fb2"]])

export default __exports__